import backendService from './backendService';

export function getCurableBannerById(bannerId) {
  return backendService.layout.v4.getCurableBanner(bannerId);
}
